import React, { useState } from "react";
import { jovashiTestData, sendInfo } from "../../data/JovashiTestData";
import { jovashiTestAnalysis } from "../Form/helpers/jovashiTestAnalysis";
import UserDataForm from "./UserDataForm";
import QuestionForm from "./QuestionForm";
import sendEmail from "../../helpers/sendEmail";
import { useNavigate } from "react-router-dom";
import { getPdfUrl, postTestResult } from "../../shared/api/results";
import { personalizePDF } from "./helpers/personalizePDF";
import { capitalizeFullName } from "../../helpers/capitalizeFullName";

const JovashiForm = () => {
  const [answers, setAnswers] = useState({});
  const [fio, setFio] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const test = "Профессиональные интересы";
  const navigate = useNavigate();
  const handleAnswerChange = (questionId, optionId) => {
    setAnswers((prevAnswers) => {
      const question = jovashiTestData.find((q) => q.id === questionId);

      if (question.maxChoices === 1) {
        return {
          ...prevAnswers,
          [questionId]: [optionId],
        };
      }

      const currentAnswers = prevAnswers[questionId] || [];
      const isSelected = currentAnswers.includes(optionId);

      if (isSelected) {
        return {
          ...prevAnswers,
          [questionId]: currentAnswers.filter((id) => id !== optionId),
        };
      }

      if (currentAnswers.length < question.maxChoices) {
        return {
          ...prevAnswers,
          [questionId]: [...currentAnswers, optionId],
        };
      }

      return prevAnswers;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!fio.trim()) {
      alert("Пожалуйста, введите ваше ФИО.");
      return;
    }
    const formattedFio = capitalizeFullName(fio)
    const unansweredQuestions = jovashiTestData.filter((question) => {
      const questionAnswers = answers[question.id] || [];
      return questionAnswers.length === 0;
    });

    if (unansweredQuestions.length > 0) {
      alert(
        `Пожалуйста, ответьте на все вопросы. Неотвеченные вопросы: ${unansweredQuestions
          .map((q) => q.id)
          .join(", ")}`
      );
      return;
    }

    const value = jovashiTestAnalysis(answers);
    const scores = [value.I, value.II, value.III, value.IV, value.V, value.VI];

    const result = `
    1. Работа с людьми: ${value.I}
    2. Исследовательская деятельность: ${value.II}
    3. Работа в производственной сфере: ${value.III}
    4. Творческая деятельность: ${value.IV}
    5. Работа в сложных и не стандартных условиях: ${value.V}
    6. Планово-экономическая деятельность: ${value.VI}
  `;

    setIsLoading(true);
    try {
      const response = await fetch("/profint.pdf");
      if (!response.ok) throw new Error("PDF не найден");
      const buffer = await response.arrayBuffer();

      const clean = (str) =>
        str
          .trim()
          .replace(/[^\w\sа-яА-ЯёЁ-]/gi, "")
          .replace(/\s+/g, "_");

      const filename = `${clean(test)}_${clean(formattedFio) || "результат"}.pdf`;

      const personalizedBlob = await personalizePDF(buffer, formattedFio, scores);
      const formData = new FormData();
      formData.append("full_name", formattedFio);
      formData.append("test_name", test);
      formData.append("score", result);
      formData.append(
        "pdf",
        new File([personalizedBlob], filename, { type: "application/pdf" })
      );

      try {
        const resultPost = await postTestResult(formData);

        const resultId = resultPost.id;
        const pdfUrl = getPdfUrl(resultId);

        try {
          const directusSendInfo = {
            provider: "directus_flow",
            baseUrl: "https://crm-hr.kzn.ru",
            flowId: "9c0df71d-3ceb-4ab4-aa0c-a6806f3d89a6",
            token: "sGaLAYCUxT_HpfAaMiQNb4qzieuAtUAM",
            subjectPrefix: process.env.REACT_APP_DIRECTUS_SUBJECT_PREFIX || "HR Tests",
          };
          await sendEmail(undefined, test, formattedFio, result, pdfUrl, directusSendInfo);
        } catch (emailError) {
          console.error("Ошибка при отправке письма:", emailError);
        }

        navigate("/finish", {
          state: {
            fio: formattedFio,
            test: test,
            score: result,
            pdfUrl: pdfUrl,
            blob: personalizedBlob,
            fileName: filename,
          },
        });
      } catch (postError) {
        console.error("Ошибка при отправке результата:", postError);
        navigate("/finish", {
          state: {
            blob: personalizedBlob,
            fileName: filename,
          },
        });
      }
    } catch (error) {
      console.error("Ошибка при подготовке PDF или других данных:", error);

      navigate("/finish", {
        state: {
          error: "Не удалось подготовить результат в формате PDF.",
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-xl font-semibold text-center mb-6">{test}</h1>
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Блок с ФИО */}
        <UserDataForm fio={fio} setFio={setFio} />

        {/* Вопросы теста */}
        {jovashiTestData.map((question) => (
          <QuestionForm
            key={question.id}
            question={question}
            selectedAnswers={answers[question.id] || []}
            onAnswerChange={handleAnswerChange}
          />
        ))}

        <button
          type="submit"
          className={`w-full ${isLoading ? "bg-gray-400" : "bg-blue-500 hover:bg-blue-600"} text-lg  text-white py-2 px-4 rounded-md mt-4`}
          disabled={isLoading}
        >
          {isLoading ? "Отправка..." : "Отправить"}
        </button>
      </form>
    </div>
  );
};

export default JovashiForm;
